import ICategory from "@/apps/MoreAboutWidget/models/category";
import ISubCategory from "@/apps/MoreAboutWidget/models/sub-category";
import IContentItem from "@/apps/MoreAboutWidget/models/content-item";

export interface IMoreAboutWidgetState {
    selectedCategory: ICategory | undefined;
    subCategories: ISubCategory[];
    selectedSubCategory: string;
    subContentItems: IContentItem[];
}

export class MoreAboutWidgetState implements IMoreAboutWidgetState {
    selectedCategory!: ICategory | undefined;
    subCategories: ISubCategory[] = [];
    selectedSubCategory: string = '';
    subContentItems: IContentItem[] = [];
}
